<template>
    <!-- breadCrumb -->
    <div class="bread_crumb">
        <div class="bread_crumb_inner">
            <a href="" class="home">홈</a>
            <a href="">기부후원 단체</a>
        </div>
    </div>
    <!-- //breadCrumb -->

    <main id="main">
        <DonationGroupListForm/>
    </main>
</template>
<script>
import DonationGroupListForm from '@/components/donationGroup/DonationGroupListForm.vue';

export default {
  components: {
    DonationGroupListForm
  }
}
</script>
<style lang="">

</style>